import React from 'react';
import styled from 'styled-components';


export const ModuleHeader = styled.div`
	display: inline-block;
	margin: ${props => props.theme.moduleHeaderMargin};
	padding: ${props => props.theme.moduleHeaderPadding};
`;

export const ModuleHeaderItem = styled.span`
	display: inline-block;
	margin: ${props => props.theme.moduleHeaderItemMargin};
	padding: ${props => props.theme.moduleHeaderItemPadding};
	color: ${props => props.light ? props.theme.moduleHeaderLightItemColor || props.theme.moduleHeaderItemColor : props.theme.moduleHeaderItemColor};
	font-size: ${props => props.light ? props.theme.moduleHeaderLightItemFontSize || props.theme.moduleHeaderItemFontSize : props.theme.moduleHeaderItemFontSize};
	font-weight: ${props => props.light ? props.theme.moduleHeaderLightItemFontWeight || props.theme.moduleHeaderItemFontWeight : props.theme.moduleHeaderItemFontWeight};
	user-select: all;
`;

